import React from "react";

// Formik validation
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useFormik as useFormic } from "formik";
import callApi from "Common/utils/apiCaller";
// Image

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthIcon from "pages/AuthenticationInner/AuthIcon";
import { Link, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import LoaderComponent from "Common/Components/Loader/Loader";
import { showNotification } from "Common/utils/Notification";

const ResetPassword = (props: any) => {
  document.title = "ResetPassword | indxx";
  let [searchParams] = useSearchParams();
  const [loader, setLoader] = useState<any>(false);
  let navigate = useNavigate();
  //   const dispatch = useDispatch<any>();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  useEffect(() => {
    let q_token = searchParams.get("reset_token");
    let q_email = searchParams.get("email");
    setEmail(q_email);
    setToken(q_token);
  }, [searchParams]);
  //   const { success, error } = useSelector(selectLogin);

  const validation: any = useFormic({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Please enter your password"),
      confirmPassword: Yup.string().required("Please enter confirm password"),
    }),
    onSubmit: async (values: any) => {
      if (values?.password === values?.confirmPassword) {
        try {
          setLoader(true);
          let result = await callApi(
            `v1/admin/auth/reset-password/${token}`,
            "post",
            {
              admin: {
                contact_email: email,
                password: values?.password,
              },
            }
          );
          setLoader(false);

          if (result?.data?.isReset) {
            showNotification("Password has been reset Successfully", "success");
            setLoader(true);
            setTimeout(() => {
              navigate("/login");
              setLoader(false);
            }, 1000);
          }
        } catch (e) {
          showNotification("Please enter correct password", "error");
        }
      } else {
        showNotification("Password and Confirm Password do not match", "error");
      }
    },
  });

  React.useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add(
      "flex",
      "items-center",
      "justify-center",
      "min-h-screen",
      "py-16",
      "lg:py-10",
      "bg-slate-50",
      "dark:bg-zink-800",
      "dark:text-zink-100",
      "font-public"
    );

    return () => {
      bodyElement.classList.remove(
        "flex",
        "items-center",
        "justify-center",
        "min-h-screen",
        "py-16",
        "lg:py-10",
        "bg-slate-50",
        "dark:bg-zink-800",
        "dark:text-zink-100",
        "font-public"
      );
    };
  }, []);

  return (
    <React.Fragment>
      <ToastContainer closeButton={false} limit={1} />
      <div className="relative">
        <AuthIcon />

        <div className="mb-0 w-screen lg:mx-auto lg:w-[500px] card shadow-lg border-none shadow-slate-100 relative">
          <div className="!px-10 !py-12 card-body">
            <div className="mt-8 text-center">
              <h4 className="mb-1 text-custom-500 dark:text-custom-500">
                Reset Password
              </h4>
              {/* <p className="text-slate-500 dark:text-zink-200">
                Sign in to continue to AthHub.
              </p>  */}
            </div>

            <form
              className="mt-10"
              id="signInForm"
              onSubmit={(event: any) => {
                event.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <div className="mb-3">
                <label
                  htmlFor="password"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 pr-10"
                    placeholder="Enter password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.password || ""}
                  />
                  <button
                    type="button"
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <i className="ri-eye-line text-lg"></i>
                    ) : (
                      <i className="ri-eye-off-line text-lg"></i>
                    )}
                  </button>
                </div>
                {validation.touched.password && validation.errors.password ? (
                  <div
                    id="password-error"
                    className="mt-1 text-sm text-red-500"
                  >
                    {validation.errors.password}
                  </div>
                ) : null}
              </div>
              <div className="mb-3">
                <label
                  htmlFor="passwordConfirmInput"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Confirm Password
                </label>
                <div className="relative">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 pr-10"
                    required
                    id="passwordConfirmInput"
                    placeholder="Enter Confirm Password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.confirmPassword || ""}
                  />
                  <button
                    type="button"
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <i className="ri-eye-line text-lg"></i>
                    ) : (
                      <i className="ri-eye-off-line text-lg"></i>
                    )}
                  </button>
                </div>
                {validation.touched.confirmPassword &&
                  validation.errors.confirmPassword ? (
                  <div id="email-error" className="mt-1 text-sm text-red-500">
                    {validation.errors.confirmPassword}
                  </div>
                ) : null}
              </div>

              <div className="mt-10">
                <button
                  type="submit"
                  disabled={loader}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="w-full text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? <LoaderComponent /> : "Submit"}
                </button>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",

                    padding: "10px 0",
                  }}
                ></div>
              </div>
            </form>
            <div className="mt-5 text-center">
              <Link
                to="/login"
                className="text-custom-500 hover:text-custom-600 font-medium"
              >
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
